import { useResult } from "../../../shared/formContext/hooks/useResult";

// Result
import MacEs from "./Result/MacEs";
import Error from "@shared/Error/Error";

// Components
import Empty from "@shared/Empty/Empty";
import Loading from "../../../components/Loading/Loading";
import { __ } from "@wordpress/i18n";

// UI Messages
const UI_MESSAGES = {
    ERROR_STATUS: __("Ocorreu um erro ao carregar os resultados.", "df-simulators"),
    NO_RESULTS: __("Não há resultados disponíveis no momento.", "df-simulators"),
};

const Results = () => {
    const { resultData } = useResult();
    const {response, loading, statusCode} = resultData;

    const renderResult = () => {
        if (loading) {
            return <Loading isFull={false} overlay={false}/>;
        }

        if (!response) {
            return <Empty figure={4} message={UI_MESSAGES.NO_RESULTS} />;
        }

        if (statusCode && statusCode !== 200) {
            console.warn(UI_MESSAGES.ERROR_STATUS);
            return <Error />;
        }

        return (
            <MacEs />
        );
    };

    return (
        <div className="tool-block__component__results__result">
            {renderResult()}
        </div>
    );
};

export default Results;
